import { render } from "./ActiveBadge.vue?vue&type=template&id=296fba56&scoped=true"
import script from "./ActiveBadge.vue?vue&type=script&lang=js"
export * from "./ActiveBadge.vue?vue&type=script&lang=js"

import "./ActiveBadge.vue?vue&type=style&index=0&id=296fba56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296fba56"]])

export default __exports__